import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

function normalizeRole(user) {
  const rawRole =
    user?.access_role ||
    user?.role ||
    user?.user_role ||
    "";

  const role = String(rawRole).trim().toLowerCase();

  const aliases = {
    superuser: "admin",
    administrator: "admin",
    team_admin: "admin",
    manager: "admin",
    member: "analyst",
    user: "analyst",
  };

  return aliases[role] || role;
}

function RestoringSession() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 10,
        color: "var(--text-muted, var(--txt-lo))",
        background: "var(--app-bg, transparent)",
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: "50%",
          border: "3px solid rgba(255,255,255,0.08)",
          borderTopColor: "var(--blue, #3b82f6)",
          animation: "spin 0.8s linear infinite",
        }}
      />
      <div style={{ fontSize: 14 }}>Restoring your SignalIQ session…</div>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default function ProtectedRoute({ roles = [], children }) {
  const { user, loading, sessionRestored, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading || !sessionRestored) {
    return <RestoringSession />;
  }

  if (!user || !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const normalizedUserRole = normalizeRole(user);
  const normalizedAllowedRoles = Array.isArray(roles)
    ? roles.map((role) => String(role).trim().toLowerCase())
    : [];

  if (
    normalizedAllowedRoles.length > 0 &&
    !normalizedAllowedRoles.includes(normalizedUserRole)
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  if (children) {
    return children;
  }

  return <Outlet />;
}